export default __webpack_public_path__ + "ide-project-images/7e4164d6b66ba1f5827bc48c73f6a678.png";